import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Button, DialogActions, DialogContent } from '@mui/material';
import DropCustom from 'components/dropZone/DropCustom';
import { ModalActionProps } from 'models/AutoModals';


type UploadFileDialogProps = {
    title: string,
    accept?: { [key: string]: string[] }
    filter?: (files: File[]) => File[],
    multiple?: boolean,
} & ModalActionProps<File[]>

const UploadFileDialog = ({title, accept, filter, onFinish, multiple = false}: UploadFileDialogProps) => {
    const {t} = useTranslation();
    const [files, setFiles] = useState<File[]>([]);

    const submit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();

        files.length && onFinish(files);
    };

    return (
        <Box component="form" onSubmit={submit}>
            <DialogContent>
                <DropCustom
                    title={title}
                    options={{
                        onDropAccepted: f => setFiles(filter ? filter(f) : f),
                        accept,
                        multiple
                    }}
                />

                {files.length > 0 && (
                    <ol>
                        {files.map(file => (
                            <li key={file.name}>{file.name}</li>
                        ))}
                    </ol>
                )}
            </DialogContent>

            {files.length > 0 && (
                <DialogActions>
                    <Button type="submit">{t('upload')}</Button>
                </DialogActions>
            )}
        </Box>
    );
};

export default UploadFileDialog;
